<template>
    <div class="content">
        <div class="scenario-panel backGround innerbox">
            <div class="panel-header">
                <p class="card-title">
                    <img src="../assets/titleL.png" alt="">&nbsp;{{ oneTitle }}&nbsp;<img src="../assets/titleR.png" alt="">
                </p>
                <el-button class="header-button" type="primary" size="mini" round @click="cancel">返回</el-button>
            </div>

            <div class="section-title">目标选择</div>
            <div class="option-list target-list">
                <div
                    class="option-row target-row"
                    v-for="line in recycleRecordsT"
                    :key="line.num"
                    @click="defend(line)"
                >
                    <strong>{{ line.num }}</strong>
                    <div>
                        <span>{{ line.name }}</span>
                        <em>{{ line.scope }} · {{ line.threshold }}</em>
                    </div>
                    <span class="tag">{{ line.rate }}</span>
                    <el-checkbox v-model="line.select" :key="line.num + line.name" @click.native.stop></el-checkbox>
                </div>
            </div>

            <div class="section-title">节点选择</div>
            <div class="option-list node-list">
                <div
                    class="option-row node-row"
                    v-for="line in recycleRecordsT1"
                    :key="line.num"
                    @click="selectItem(line)"
                >
                    <strong>{{ line.num }}</strong>
                    <div>
                        <span>{{ line.name }}</span>
                        <em>{{ line.role }}</em>
                    </div>
                    <el-checkbox v-model="line.select" :key="line.num + line.name" @click.native.stop></el-checkbox>
                </div>
            </div>
        </div>

        <div class="scheme-panel backGround">
            <div class="panel-header">
                <p class="card-title">
                    <img src="../assets/titleL.png" alt="">&nbsp;调度方案&nbsp;<img src="../assets/titleR.png" alt="">
                </p>
                <el-button class="header-button" type="primary" size="mini" round @click="customization">自定义</el-button>
            </div>

            <div v-if="showFlag" class="scheme-content">
                <div
                    class="scheme-card"
                    v-for="line in displaySchemes"
                    :key="line.num"
                    :class="{ active: selectedScheme && selectedScheme.num === line.num }"
                    @click="selectScheme(line)"
                >
                    <div class="scheme-main">
                        <strong>{{ line.name }}</strong>
                        <span :class="['risk-pill', riskClass(line.risk)]">{{ line.risk }}</span>
                    </div>
                    <p>{{ line.description }}</p>
                    <div class="scheme-metrics">
                        <span>峰值下泄 {{ line.peakRelease }} m³/s</span>
                        <span>最高水位 {{ line.maxLevel }} m</span>
                        <span>削峰 {{ line.peakReduction }}%</span>
                    </div>
                    <el-button class="preview-button" type="primary" size="mini" round @click.stop="regulate(line)">预演</el-button>
                </div>

                <div v-if="selectedScheme" class="scheme-explain">
                    <div class="explain-head">
                        <div>
                            <span>当前选中</span>
                            <strong>{{ selectedScheme.name }}</strong>
                        </div>
                        <em>{{ selectedScheme.focus }}</em>
                    </div>
                    <div class="explain-grid">
                        <p><span>防护侧重</span><strong>{{ selectedScheme.controlTarget }}</strong></p>
                        <p><span>淹没面积</span><strong>{{ selectedScheme.inundationArea }} km²</strong></p>
                        <p><span>到峰时间</span><strong>{{ selectedScheme.peakTime }}</strong></p>
                        <p><span>适用条件</span><strong>{{ selectedScheme.condition }}</strong></p>
                    </div>
                </div>

                <div v-if="huadongModelCards.length" class="model-chain-card">
                    <div class="timeline-title">
                        <span>水文模型联算</span>
                        <em>{{ huadong && huadong.metrics ? huadong.metrics.warning_level_cn : '接口联算' }}</em>
                    </div>
                    <div class="model-chain-grid">
                        <p v-for="item in huadongModelCards" :key="item.name">
                            <span>{{ item.name }}</span>
                            <strong>{{ item.value }}</strong>
                        </p>
                    </div>
                    <div v-if="forecastModelBadges.length" class="model-status-grid">
                        <div
                            v-for="model in forecastModelBadges"
                            :key="model.model_id"
                            :class="['model-status-pill', model.status === 'available' ? 'available' : 'contract']"
                        >
                            <strong>{{ model.model_id }}</strong>
                            <span>{{ model.status === 'available' ? '已接入' : '契约待训练' }}</span>
                        </div>
                    </div>
                </div>

                <div class="timeline-card">
                    <div class="timeline-title">
                        <span>24小时洪水演进过程线</span>
                        <em>入流 / 下泄 / 水位 / 淹没面积</em>
                    </div>
                    <div ref="timelineChart" class="timeline-chart"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { scaleFloodSchemeForFrequency } from '@/services/floodFrequency.js'
import { fetchForecastModels } from '@/services/hydroService.js'

export default {
    name: "prolusion",
    props: {
        workflow: {
            type: Object,
            default: null
        },
        scenario: {
            type: Object,
            default: null
        },
        autoRunSchemeNum: {
            type: Number,
            default: null
        },
        huadong: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            oneTitle: "龙门预演场景构建",
            dialogVisible: false,
            showFlag: true,
            value: '',
            selectedScheme: null,
            chartResizeHandler: null,
            forecastModels: [],
            recycleRecordsT: [
                {
                    num: 1,
                    name: '居民区',
                    rate: '一般防护对象',
                    scope: '龙门下游村镇',
                    threshold: '预警水位 459.8 m',
                    select: true
                },
                {
                    num: 2,
                    name: '农田',
                    rate: '一般防护对象',
                    scope: '沿河滩区耕地',
                    threshold: '允许短时漫滩',
                    select: false
                }
            ],
            recycleRecordsT1: [
                {
                    num: 1,
                    name: '水文站1',
                    role: '龙门上游入流控制断面',
                    select: true
                },
                {
                    num: 3,
                    name: '大坝',
                    role: '古贤枢纽闸门与库水位控制节点',
                    select: true
                },
                {
                    num: 4,
                    name: '水文站2',
                    role: '龙门下游洪峰传播校核断面',
                    select: true
                },
            ],
            recycleRecordsT2: [
                {
                    num: 1,
                    name: '下泄方案1',
                    focus: '保守控泄',
                    risk: '低风险',
                    controlTarget: '优先保护居民区，严格限制下游水位抬升',
                    description: '通过分阶段小幅开闸削减龙门断面涨率，下游更安全，但库水位抬升更明显。',
                    condition: '居民区敏感、下游转移窗口不足',
                    peakRelease: 1650,
                    maxLevel: 617.92,
                    peakReduction: 41,
                    inundationArea: 1.8,
                    peakTime: '第 10 小时',
                    timeline: {
                        time: ['0h', '2h', '4h', '6h', '8h', '10h', '12h', '16h', '20h', '24h'],
                        inflow: [1120, 1680, 2460, 3380, 4210, 4680, 3920, 2850, 1960, 1320],
                        release: [820, 980, 1160, 1320, 1480, 1650, 1580, 1390, 1160, 940],
                        level: [616.20, 616.45, 616.88, 617.32, 617.70, 617.92, 617.82, 617.48, 617.05, 616.66],
                        area: [0.2, 0.4, 0.7, 1.0, 1.5, 1.8, 1.6, 1.1, 0.6, 0.3]
                    }
                },
                {
                    num: 2,
                    name: '下泄方案2',
                    focus: '均衡调度',
                    risk: '中风险',
                    controlTarget: '兼顾居民区、农田和水库防洪库容',
                    description: '推荐演示方案。提前预泄并在洪峰期稳定控泄，库水位和下游淹没范围都处于可控区间。',
                    condition: '常规20年一遇洪水、下游预警已到位',
                    peakRelease: 2050,
                    maxLevel: 617.38,
                    peakReduction: 34,
                    inundationArea: 2.4,
                    peakTime: '第 9 小时',
                    timeline: {
                        time: ['0h', '2h', '4h', '6h', '8h', '10h', '12h', '16h', '20h', '24h'],
                        inflow: [1120, 1680, 2460, 3380, 4210, 4680, 3920, 2850, 1960, 1320],
                        release: [980, 1280, 1560, 1840, 2050, 1980, 1840, 1580, 1260, 1040],
                        level: [616.18, 616.34, 616.62, 616.96, 617.28, 617.38, 617.22, 616.90, 616.58, 616.32],
                        area: [0.3, 0.6, 1.0, 1.5, 2.1, 2.4, 2.0, 1.3, 0.8, 0.4]
                    }
                },
                {
                    num: 3,
                    name: '下泄方案3',
                    focus: '快速泄洪',
                    risk: '较高风险',
                    controlTarget: '优先降低库水位，快速腾出防洪库容',
                    description: '加大下泄为后续洪峰预留库容，水库侧风险最低，但龙门下游农田和低洼道路受影响更大。',
                    condition: '后续仍有强降雨、需提前腾库',
                    peakRelease: 2480,
                    maxLevel: 616.82,
                    peakReduction: 24,
                    inundationArea: 3.6,
                    peakTime: '第 8 小时',
                    timeline: {
                        time: ['0h', '2h', '4h', '6h', '8h', '10h', '12h', '16h', '20h', '24h'],
                        inflow: [1120, 1680, 2460, 3380, 4210, 4680, 3920, 2850, 1960, 1320],
                        release: [1320, 1680, 2080, 2360, 2480, 2320, 2050, 1720, 1380, 1080],
                        level: [616.12, 616.20, 616.34, 616.58, 616.82, 616.76, 616.54, 616.28, 616.10, 615.94],
                        area: [0.5, 0.9, 1.6, 2.7, 3.6, 3.3, 2.6, 1.7, 1.0, 0.5]
                    }
                }
            ]
        }
    },
    computed: {
        displaySchemes() {
            const frequency = this.workflow && this.workflow.frequency ? this.workflow.frequency : '20年一遇'
            return this.recycleRecordsT2.map(item => scaleFloodSchemeForFrequency(item, frequency))
        },
        huadongModelCards() {
            const metrics = this.huadong && this.huadong.metrics
            if (!metrics) return []
            return [
                { name: '四模型预报', value: metrics.forecast_summary || '新安江、GR4J、RF、LSTM 已完成' },
                { name: '趋势诊断', value: metrics.analysis_summary || '趋势/周期/突变分析完成' },
                { name: '集合订正', value: `${metrics.ensemble_summary || '多模型集合完成'}；${metrics.correction_summary || '误差订正完成'}` },
                { name: '风险预警', value: `${metrics.risk_summary || '超阈概率完成'}；${metrics.warning_summary || metrics.warning_level_cn || '预警分析完成'}` },
            ]
        },
        forecastModelBadges() {
            return this.forecastModels.map(item => ({
                model_id: item.model_id,
                status: item.status,
            }))
        }
    },
    mounted() {
        this.init()
        this.loadForecastModels()
        this.selectedScheme = this.displaySchemes[1]
        this.chartResizeHandler = () => {
            if (this._timelineChart) this._timelineChart.resize()
        }
        window.addEventListener('resize', this.chartResizeHandler)
        this.$nextTick(this.renderTimeline)
        this.$nextTick(this.applyAutoRunScheme)
    },
    watch: {
        autoRunSchemeNum() {
            this.$nextTick(this.applyAutoRunScheme)
        },
        workflow: {
            deep: true,
            handler() {
                this.$nextTick(this.applyAutoRunScheme)
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.chartResizeHandler)
        if (this._timelineChart) {
            this._timelineChart.dispose()
            this._timelineChart = null
        }
    },
    methods: {
        init() {

        },
        async loadForecastModels() {
            try {
                const registry = await fetchForecastModels()
                this.forecastModels = Array.isArray(registry.models) ? registry.models : []
            } catch (error) {
                console.warn('[prolusion] forecast model registry unavailable:', error)
                this.forecastModels = []
            }
        },
        selectItem(item) {
            if (item.num === 3 && !item.select) {
                this.showFlag = true
            }
            if (item.num === 3 && item.select) {
                this.showFlag = false
            }
        },
        selectScheme(item) {
            this.selectedScheme = item
            this.$nextTick(this.renderTimeline)
        },
        startFlow() {
            this.$emit('nextChange')
        },
        regulate(item) {
            const payload = this.buildSchemePayload(item)
            this.selectScheme(payload)
            this.$emit('adjust', payload, this.selectedDefendTargets())
        },
        buildSchemePayload(item) {
            return {
                ...item,
                floodScenario: this.scenario || item.floodScenario || null,
                workflow: this.workflow || null,
                height_max: item.num === 1 ? 462 : item.num === 2 ? 460 : 458
            }
        },
        selectedDefendTargets() {
            const selected = this.recycleRecordsT.filter(item => item.select)
            return selected.length ? selected : this.recycleRecordsT
        },
        applyAutoRunScheme() {
            const frequency = this.workflow && this.workflow.frequency ? this.workflow.frequency : '20年一遇'
            const token = `${this.autoRunSchemeNum || 2}-${frequency}`
            if (!this.autoRunSchemeNum && this.selectedScheme) return
            if (this._autoRunDone === token) return
            const scheme = this.displaySchemes.find(item => item.num === this.autoRunSchemeNum) || this.displaySchemes[1]
            this._autoRunDone = token
            this.selectScheme(this.buildSchemePayload(scheme))
        },
        defend(item) {
            item.select = !item.select
            this.$emit('conservation', item)
        },
        customization() {
            this.$emit('customization')
        },
        cancel() {
            this.$emit('nextChange')
        },
        riskClass(risk) {
            if (risk === '较高风险' || risk === '高风险' || risk === '极高风险') return 'risk-high'
            if (risk === '中风险') return 'risk-mid'
            return 'risk-low'
        },
        renderTimeline() {
            if (!this.$refs.timelineChart || !this.selectedScheme || !this.$echarts) return
            if (!this._timelineChart) {
                this._timelineChart = this.$echarts.init(this.$refs.timelineChart)
            }
            const timeline = this.selectedScheme.timeline
            const minLevel = Math.max(614.5, Math.min(...timeline.level) - 0.3)
            const maxLevel = Math.max(...timeline.level) + 0.35
            const maxArea = Math.max(4, Math.max(...timeline.area) * 1.18)
            this._timelineChart.setOption({
                color: ['#7ee6ff', '#ffd36a', '#7dffbc', '#ff8f7a'],
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(2, 22, 30, 0.92)',
                    borderColor: 'rgba(126, 230, 255, 0.35)',
                    textStyle: { color: '#eaffff' }
                },
                legend: {
                    top: 0,
                    textStyle: { color: 'rgba(230, 247, 251, 0.82)', fontSize: 10 },
                    data: ['入库流量', '下泄流量', '库水位', '淹没面积']
                },
                grid: { left: 42, right: 58, top: 32, bottom: 26 },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: timeline.time,
                    axisLine: { lineStyle: { color: 'rgba(230, 247, 251, 0.25)' } },
                    axisLabel: { color: 'rgba(230, 247, 251, 0.78)', fontSize: 10 }
                },
                yAxis: [
                    {
                        type: 'value',
                        name: 'm³/s',
                        min: 0,
                        axisLine: { show: false },
                        splitLine: { lineStyle: { color: 'rgba(255, 255, 255, 0.06)' } },
                        axisLabel: { color: 'rgba(230, 247, 251, 0.72)', fontSize: 10 }
                    },
                    {
                        type: 'value',
                        name: 'm',
                        min: Number(minLevel.toFixed(2)),
                        max: Number(maxLevel.toFixed(2)),
                        axisLine: { show: false },
                        splitLine: { show: false },
                        axisLabel: { color: 'rgba(230, 247, 251, 0.72)', fontSize: 10 }
                    },
                    {
                        type: 'value',
                        name: 'km²',
                        min: 0,
                        max: Number(maxArea.toFixed(1)),
                        offset: 36,
                        axisLine: { show: false },
                        splitLine: { show: false },
                        axisLabel: { color: 'rgba(230, 247, 251, 0.72)', fontSize: 10 }
                    }
                ],
                series: [
                    { name: '入库流量', type: 'line', smooth: true, data: timeline.inflow, symbolSize: 5, areaStyle: { opacity: 0.08 } },
                    { name: '下泄流量', type: 'line', smooth: true, data: timeline.release, symbolSize: 5 },
                    { name: '库水位', type: 'line', smooth: true, yAxisIndex: 1, data: timeline.level, symbolSize: 5 },
                    { name: '淹没面积', type: 'line', smooth: true, yAxisIndex: 2, data: timeline.area, symbolSize: 5 }
                ]
            })
            this._timelineChart.resize()
        }
    }
}
</script>

<style scoped>
.backGround {
    position: relative;
    background: url(../assets/twoR.png) no-repeat center center;
    background-size: 100% 100%;
}

/deep/ .el-dialog,
.el-pager li {
    background-color: rgba(30, 144, 255, 0.0);
    background-image: url(../assets/twoR.png);
    background-size: 100% 100%;
}

::v-deep .el-input__inner {
border: 1px solid rgba(56, 189, 248, 0.24);
	background-color: transparent !important;
}

.content {
    width: 29%;
    height: calc(100vh - 126px);
    position: absolute;
    left: 10px;
    top: 90px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    color: #e6f7fb;
}

.scenario-panel {
    height: 34%;
    padding: 10px 12px;
    box-sizing: border-box;
    min-height: 250px;
}

.scheme-panel {
    flex: 1;
    min-height: 0;
    padding: 10px 12px;
    box-sizing: border-box;
    overflow: auto;
}

.panel-header {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.card-title {
    color: #fff;
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    display: flex;
    align-items: center;
}

.header-button {
    background-color: #69ca62;
    border: none;
}

.section-title {
    margin: 8px 0 6px;
    color: #9ceff2;
    font-size: 13px;
    font-weight: 600;
}

.option-list {
    display: grid;
    gap: 6px;
}

.target-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.node-list {
    grid-template-columns: 1fr;
}

.option-row,
.scheme-card,
.scheme-explain,
.timeline-card {
    border: 1px solid rgba(99, 179, 237, 0.28);
    background: rgba(8, 18, 32, 0.46);
    border-radius: 6px;
}

.option-row {
    min-height: 44px;
    display: grid;
    grid-template-columns: 24px minmax(0, 1fr) auto auto;
    align-items: center;
    gap: 8px;
    padding: 7px 8px;
    cursor: pointer;
}

.node-row {
    grid-template-columns: 24px minmax(0, 1fr) auto;
}

.option-row strong {
    color: #fff;
    font-size: 15px;
}

.option-row span {
    display: block;
    color: #fff;
    font-size: 13px;
}

.option-row em {
    display: block;
    margin-top: 2px;
    color: rgba(230, 247, 251, 0.68);
    font-size: 11px;
    font-style: normal;
}

.tag {
    padding: 2px 6px;
    border-radius: 999px;
    background: rgba(56, 189, 248, 0.12);
    color: #76d9ff !important;
    white-space: nowrap;
}

.scheme-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.scheme-card {
    position: relative;
    padding: 9px 76px 9px 10px;
    cursor: pointer;
}

.scheme-card.active {
    border-color: rgba(56, 189, 248, 0.48);
    background: rgba(56, 189, 248, 0.06);
}

.scheme-main,
.explain-head,
.timeline-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.scheme-main strong,
.explain-head strong {
    color: #fff;
    font-size: 14px;
}

.scheme-card p {
    margin: 6px 0;
    color: rgba(230, 247, 251, 0.78);
    line-height: 1.45;
    font-size: 12px;
}

.scheme-metrics {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
}

.scheme-metrics span,
.explain-grid p {
    background: rgba(255, 255, 255, 0.045);
    border-radius: 4px;
    padding: 5px 6px;
    color: rgba(230, 247, 251, 0.85);
    font-size: 11px;
}

.preview-button {
    position: absolute;
    right: 10px;
    top: 42px;
    background-color: #14d7d7;
    border: none;
    color: #002a30;
}

.risk-pill {
    padding: 3px 7px;
    border-radius: 999px;
    font-size: 11px;
    white-space: nowrap;
}

.risk-high {
    background: rgba(255, 96, 64, 0.18);
    color: #ffc1b4;
}

.risk-mid {
    background: rgba(255, 196, 67, 0.18);
    color: #ffe29b;
}

.risk-low {
    background: rgba(0, 210, 150, 0.15);
    color: #a7ffdf;
}

.scheme-explain,
.model-chain-card,
.timeline-card {
    padding: 9px 10px;
}

.explain-head span,
.timeline-title em {
    color: rgba(230, 247, 251, 0.62);
    font-size: 11px;
}

.explain-head em {
    color: #9ceff2;
    font-style: normal;
    font-size: 12px;
}

.explain-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
    margin-top: 8px;
}

.explain-grid p {
    margin: 0;
}

.explain-grid span {
    display: block;
    color: rgba(230, 247, 251, 0.62);
}

.explain-grid strong {
    display: block;
    margin-top: 3px;
    color: #fff;
    line-height: 1.35;
}

.timeline-title span {
    color: #76d9ff;
    font-size: 13px;
    font-weight: 600;
}

.timeline-chart {
    height: 230px;
    width: 100%;
}

.model-chain-card {
    border: 1px solid rgba(99, 179, 237, 0.28);
    background: rgba(8, 18, 32, 0.35);
}

.model-chain-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 6px;
    margin-top: 8px;
}

.model-chain-grid p {
    min-width: 0;
    margin: 0;
    padding: 6px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.045);
}

.model-chain-grid span {
    display: block;
    margin-bottom: 3px;
    color: rgba(230, 247, 251, 0.62);
    font-size: 11px;
}

.model-chain-grid strong {
    display: -webkit-box;
    overflow: hidden;
    color: rgba(255, 255, 255, 0.9);
    font-size: 11px;
    line-height: 1.35;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

.model-status-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
    margin-top: 8px;
}

.model-status-pill {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    min-height: 26px;
    padding: 4px 7px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.045);
}

.model-status-pill strong {
    color: #fff;
    font-size: 11px;
    text-transform: uppercase;
}

.model-status-pill span {
    color: rgba(230, 247, 251, 0.72);
    font-size: 10px;
    white-space: nowrap;
}

.model-status-pill.available {
    border-color: rgba(0, 210, 150, 0.32);
    background: rgba(0, 210, 150, 0.10);
}

.model-status-pill.contract {
    border-color: rgba(255, 196, 67, 0.32);
    background: rgba(255, 196, 67, 0.10);
}

@media (max-width: 1280px) {
    .content {
        width: 34%;
    }
    .target-list,
    .scheme-metrics,
    .explain-grid,
    .model-chain-grid {
        grid-template-columns: 1fr;
    }

    .model-status-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}
</style>
